import { sanitizeRedirectTarget } from '@peanuds/composables';

export const DEFAULT_POST_LOGIN_REDIRECT_TARGET = '/';
export const POST_LOGIN_REDIRECT_TARGET_STORAGE_KEY = 'auth_redirect_target';

const AUTH_ROUTE_PREFIXES = ['/auth', '/login', '/logout', '/signup'] as const;

const getSessionStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage;
};

const getRedirectPath = (target: string) => {
  return target.split(/[?#]/, 1)[0] ?? DEFAULT_POST_LOGIN_REDIRECT_TARGET;
};

const isAuthRouteTarget = (target: string) => {
  const redirectPath = getRedirectPath(target);

  return AUTH_ROUTE_PREFIXES.some((routePrefix) => {
    return redirectPath === routePrefix || redirectPath.startsWith(`${routePrefix}/`);
  });
};

export const resolvePostLoginRedirectTarget = (redirect: unknown) => {
  const target = sanitizeRedirectTarget(redirect, DEFAULT_POST_LOGIN_REDIRECT_TARGET);

  if (isAuthRouteTarget(target)) {
    return DEFAULT_POST_LOGIN_REDIRECT_TARGET;
  }

  return target;
};

export const getStoredPostLoginRedirectTarget = () => {
  return resolvePostLoginRedirectTarget(
    getSessionStorage()?.getItem(POST_LOGIN_REDIRECT_TARGET_STORAGE_KEY),
  );
};

export const storePostLoginRedirectTarget = (redirect: unknown) => {
  const target = resolvePostLoginRedirectTarget(redirect);
  const storage = getSessionStorage();

  try {
    storage?.setItem(POST_LOGIN_REDIRECT_TARGET_STORAGE_KEY, target);
  } catch (error) {
    console.warn('[Auth] Failed to store post-login redirect target.', error);
  }

  return target;
};

export const clearPostLoginRedirectTarget = () => {
  getSessionStorage()?.removeItem(POST_LOGIN_REDIRECT_TARGET_STORAGE_KEY);
};

export const consumePostLoginRedirectTarget = () => {
  const target = getStoredPostLoginRedirectTarget();

  clearPostLoginRedirectTarget();

  return target;
};
